var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 22,
    viewBox: "0 0 512 512",
    width: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m418.364 0-418.364 418.364 93.636 93.636 418.364-418.364zm-396.211 418.364 16.443-16.443 54.875 54.875 11.076-11.076-54.875-54.875 10.939-10.939 16.477 16.477 11.076-11.077-16.477-16.477 10.939-10.939 27.485 27.485 11.077-11.076-27.485-27.485 10.939-10.939 16.477 16.477 11.076-11.077-16.477-16.477 10.939-10.939 54.874 54.875 11.076-11.077-54.875-54.875 10.939-10.939 16.477 16.477 11.076-11.076-16.476-16.474 10.939-10.939 27.485 27.485 11.076-11.076-27.485-27.485 10.939-10.939 16.477 16.477 11.076-11.076-16.477-16.477 10.939-10.939 54.874 54.875 11.077-11.076-54.874-54.875 10.939-10.939 16.477 16.477 11.076-11.076-16.477-16.477 10.939-10.939 27.485 27.485 11.076-11.076-27.479-27.49 10.939-10.939 16.477 16.477 11.077-11.076-16.477-16.477 10.939-10.939 54.875 54.875 11.077-11.076-54.875-54.874 10.939-10.939 16.477 16.477 11.077-11.076-16.477-16.477 10.939-10.939 27.485 27.485 11.076-11.076-27.489-27.487 10.939-10.939 16.477 16.477 11.077-11.076-16.478-16.477 10.939-10.939 54.875 54.875 11.076-11.076-54.875-54.875 16.443-16.443 71.482 71.482-396.208 396.209z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.6b2b3cf44d0df5e785ebfc2d9955288f.svg";
export { ForwardRef as ReactComponent };